import * as React from "react";
import { useApiService, useTl } from "../../../../hooks";
import { CharacteristicApi } from "../../../../api";
import { useHistory, useParams } from "react-router";
import { useApiEffect } from "nsitools-react";
import { PageBase, BackButton, ProtectedTabs } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import {Tab, Spinner, SpinnerSize} from "@blueprintjs/core";
import { useGlobalData } from "../../../../contexts";
import { CharacteristicsDetailPage } from "..";

export interface ICharacteristicsItemPageProps {}

export const CharacteristicsItemPage: React.FunctionComponent<ICharacteristicsItemPageProps> = (props) => {
  const { id, tab, state } = useParams<{ id: string; tab: string; state: string }>();
  const { currentLanguage } = useGlobalData();
  const history = useHistory();
  const { t } = useTl();
  const api = useApiService(CharacteristicApi);
  const [displayName, loading] = useApiEffect(() => api.getDisplayName(+id, currentLanguage.languageId), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.Characteristics), route: ERoutes.characteristics },
        { text: +id > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New) },
      ]}
    >
      <ProtectedTabs
        id="TabsCharacteristics"
        onChange={(newTabId) => history.push(`${ERoutes.characteristics}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.characteristics} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<CharacteristicsDetailPage characteristicId={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
